import { PlanPaymentType } from '@/enums/PlanPaymentType'
import { getBlankEft } from '@/mixins/eft'
import type { EFT, PlanData } from '@/types'

export interface v1PlanData {
	payment?:
		| {
				paymentType: PlanPaymentType.EFT
				paymentDetails: {
					bankName: string
					routingNumber: string
					routingNumber_confirm?: string
					accountNumber: string
					accountNumber_confirm?: string
					accountType: 'Checking' | 'Savings'

					ongoingBankName: string
					ongoingRoutingNumber: string
					ongoingRoutingNumber_confirm?: string
					ongoingAccountNumber: string
					ongoingAccountNumber_confirm?: string
					ongoingAccountType: 'Checking' | 'Savings'

					useDifferentOngoingAccount: boolean
				}
		  }
		| {
				paymentType: PlanPaymentType.CreditCard
				paymentDetails: {
					token: string
				}
		  }
		| {
				paymentType: PlanPaymentType.DirectBill
				paymentDetails: {
					billingType: 'Monthly' | 'Quarterly' | 'Semi-Annual' | 'Annual'
				}
		  }
}

export function planV2EftMigration(
	planData: Partial<v1PlanData>
): Partial<PlanData> {
	if (!planData.payment?.paymentType) {
		return {
			...planData,
			payment: {
				paymentType: PlanPaymentType.EFT,
				paymentDetails: {
					initialAccount: getBlankEft(),
					ongoingAccount: getBlankEft(),
					useDifferentOngoingAccount: false,
				},
			},
		}
	}

	if (planData.payment?.paymentType !== PlanPaymentType.EFT) {
		return planData as Partial<PlanData>
	}

	const details = planData.payment.paymentDetails

	const initialAccount: EFT = {
		accountHolder: '',
		accountNumber: details?.accountNumber ?? '',
		accountNumber_confirm: details?.accountNumber_confirm ?? '',
		bankName: details?.bankName ?? '',
		accountType: details.accountType === 'Savings' ? 'savings' : 'checking',
		routingNumber: details?.routingNumber ?? '',
		routingNumber_confirm: details?.routingNumber_confirm ?? '',
	}

	const ongoingAccount: EFT = {
		accountHolder: '',
		accountNumber: details?.ongoingAccountNumber ?? '',
		accountNumber_confirm: details?.ongoingAccountNumber_confirm ?? '',
		bankName: details?.ongoingBankName ?? '',
		accountType:
			details.ongoingAccountType === 'Savings' ? 'savings' : 'checking',
		routingNumber: details?.ongoingRoutingNumber ?? '',
		routingNumber_confirm: details?.ongoingRoutingNumber_confirm ?? '',
	}

	return {
		...planData,
		payment: {
			paymentType: PlanPaymentType.EFT,
			paymentDetails: {
				initialAccount,
				ongoingAccount,
				useDifferentOngoingAccount: details.useDifferentOngoingAccount ?? false,
			},
		},
	}
}
